import type { Schemas } from '@npc/api-client'

function seriesWiped(series: Schemas['MetricSeries']): boolean {
  return series.stale === true || series.unknown === true
}

export function probeLive(host: Schemas['Host'], metrics: Schemas['MetricSeries'][]): boolean {
  // Agent-only worker 设计上没有 SSH daemon。它的在线事实由后端根据
  // status + agent_last_seen_at 算好，不再用是否有 SSH 指标序列反推。
  if (host.agent_only) return host.probe_live === true
  if (host.status === 'offline' || host.status === 'error') return false
  if (metrics.length === 0) return false
  // 后端 R18：探针不在场时仍会回 24 根空柱 + stale/unknown。
  // 只看 series.length 会把「上次的数」当成现在。
  if (metrics.some(seriesWiped)) return false
  return true
}
